import React, { useState } from 'react';
import { MAX_TAGS, normalizeTags } from '../utils/scoreTags';
import '../styles/ScoreTags.css';

export default function ScoreTags({ tags, onChange, locale }) {
  const [draft, setDraft] = useState('');
  const isJapanese = locale === 'ja';
  const commit = () => {
    if (!draft.trim()) return;
    onChange(normalizeTags([...tags, draft]));
    setDraft('');
  };
  return (
    <div className="score-tags-editor">
      <span className="score-tags-label">{isJapanese ? 'ハッシュタグ' : 'Hashtags'}</span>
      <div className="score-tags" aria-label={isJapanese ? '曲のハッシュタグ' : 'Score hashtags'}>
        {tags.map((tag) => (
          <span className="score-tag" key={tag}>
            #{tag}
            <button type="button" onClick={() => onChange(tags.filter((value) => value !== tag))} aria-label={isJapanese ? `${tag}を削除` : `Remove ${tag}`}>×</button>
          </span>
        ))}
        {tags.length < MAX_TAGS && (
          <input
            className="score-tag-input"
            value={draft}
            onChange={(event) => setDraft(event.target.value)}
            onBlur={commit}
            onKeyDown={(event) => {
              if (event.nativeEvent.isComposing || event.keyCode === 229) return;
              if (event.key === 'Enter' || event.key === ',') { event.preventDefault(); commit(); }
            }}
            placeholder={isJapanese ? '＋ タグを追加（Enterで確定）' : '+ Add tags (press Enter)'}
            aria-label={isJapanese ? 'ハッシュタグを追加' : 'Add hashtags'}
          />
        )}
      </div>
      {tags.length >= MAX_TAGS && <small>{isJapanese ? 'タグは20個まで追加できます' : 'Up to 20 tags'}</small>}
    </div>
  );
}
